import script from "./AnswerMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./AnswerMessage.vue?vue&type=script&setup=true&lang=js"

import "./AnswerMessage.vue?vue&type=style&index=0&id=1089290b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1089290b"]])

export default __exports__